import React, { useCallback } from 'react'
import clsx from 'clsx'
import { Button, ListItem } from '@material-ui/core'
import { useStyles } from './PostGraduationTabs.styles'

type Props = {
  title: string
  index: number
  setSelectedTab: (index: number) => void
  active: boolean
  disabled?: boolean
}

const PostGraduationTabButton = ({
  title,
  index,
  setSelectedTab,
  active,
  disabled
}: Props) => {
  const classes = useStyles()
  const handleClick = useCallback(() => {
    setSelectedTab(index)
  }, [index, setSelectedTab])
  return (
    <ListItem className={classes.tabListItem}>
      <Button
        disableRipple
        disabled={disabled}
        onClick={handleClick}
        className={clsx(classes.tabButton, {
          [classes.activeTabButton]: active
        })}
      >
        {title}
      </Button>
    </ListItem>
  )
}

export default PostGraduationTabButton
